import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9003/api'

export const getSchemaPaymentSave = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/payment`
  return doGet(url)
}

export const getSchemaBudget = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/budget`
  return doGet(url)
}

export const getSchemaPaymentPlanSave = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/budget-plan`
  return doGet(url)
}

export const savePayment = (request) => {
  const url = `${API_ROOT}/review/payment`
  return doPost(url, request)
}

export const saveBudgetPlan = (request) => {
  const url = `${API_ROOT}/review/budget-plan`
  return doPost(url, request)
}

export const saveBudgetPlanAtInstallmentStep = (request, projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/budget/plan`
  return doPost(url, request)
}

export const saveBudgetInstallmentPlan = (request, projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/budget/installment`
  return doPost(url, request)
}

export const saveYearAndData = (request, projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/payment/categoryofcost`
  return doPost(url, request)
}

export const saveCost = (request, projectVersionId) => {
  //  const API_ROOT = "http://localhost:80/api"
  const url = `${API_ROOT}/review/${projectVersionId}/payment/categorycost`
  return doPost(url, request)
}

export const saveDetail = (request, projectVersionId, categoryOfCostId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/payment/categoryofcost/${categoryOfCostId}/detail`
  return doPost(url, request)
}

export const deletePeriod = (projectVersionId, categoryOfCostId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/payment/categoryofcost/${categoryOfCostId}`
  return doDelete(url)
}

//บันทึกงวดเงินหลายโครงการ
export const getSchemaPaymentSaveMulti = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/budget/page/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const savePaymentMulti = (request) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/budget/add`
  return doPost(url, request)
}

export const saveBudgetInstallmentPlanMulti = (request) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/budget/installment`
  return doPost(url, request)
}

//บันทึกแผนงบประมาณหลายโครงการ
export const saveBudgetPlanMuti = (request) => {
  const url = `${API_ROOT}/review/multi/budget-plan`
  return doPost(url, request)
}
export const saveBudgetPlanAtInstallmentStepMuti = (request) => {
  const url = `${API_ROOT}/review/multi/budget-plan/installment`
  return doPost(url, request)
}

//Change Payment นักวิชาการแก้ไขงวดเงินในแก้ไขสัญญาหลังลงนาม
export const getChangePayment = (projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/change/payment`
  return doGet(url)
}

export const saveChangePayment = (request, projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/change/payment`
  return doPost(url, request)
}

//sub project
export const getSchemaSubPaymentSave = (projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment`
  return doGet(url)
}

export const saveSubYearAndData = (request, projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment/categoryofcost`
  return doPost(url, request)
}

export const saveSubCost = (request, projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment/categorycost`
  return doPost(url, request)
}

export const saveSubDetail = (request, projectVersionId, categoryOfCostId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment/categoryofcost/${categoryOfCostId}/detail`
  return doPost(url, request)
}

export const deleteSubPeriod = (projectVersionId, categoryOfCostId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment/categoryofcost/${categoryOfCostId}`
  return doDelete(url)
}

export const getProjectCategoryCostCheck = (projectVersionId, request) => {
  //  const API_ROOT = "http://localhost:80/api"
  const url = `${API_ROOT}/review/${projectVersionId}/project/category-cost-check`
  return doPost(url, request)
}

//sub project new
export const getSchemaSubPaymentSaveNew = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/payment-new?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const saveSubYearAndDataNew = (request, projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/payment-new/categoryofcost?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}

export const saveSubDetailNew = (request, projectVersionId, categoryOfCostId, projectCode) => {
  const url = `${API_ROOT}/subproject/payment-new/categoryofcost/${categoryOfCostId}/detail?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}

export const deleteSubPeriodNew = (projectVersionId, categoryOfCostId, projectCode) => {
  const url = `${API_ROOT}/subproject/payment-new/categoryofcost/${categoryOfCostId}?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doDelete(url)
}

export const sendSubmitReview = (request, projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/payment-new/submit-review?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}
